import { jsxs, Fragment } from "react/jsx-runtime";
import { useBulkRowActionsContext } from "../../context/useBulkRowActionsContext.js";
import { useFindAndReplaceContext } from "../../context/useFindAndReplaceContext.js";
import { useSearchValueContext } from "../../context/useSearchValueContext.js";
import { useClipboardActionsContext } from "../../context/useClipboardActions.js";
import { useKeyActionsContext } from "../../context/useKeyActions.js";
const TablePortal = () => {
  const findAndReplaceModal = useFindAndReplaceContext();
  const searchValueModal = useSearchValueContext();
  const { bulkRowActionsModal } = useBulkRowActionsContext();
  const { copyAlertModal, pasteAlertModal } = useClipboardActionsContext();
  const { deleteAlertModal } = useKeyActionsContext();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    findAndReplaceModal == null ? void 0 : findAndReplaceModal.render(),
    searchValueModal == null ? void 0 : searchValueModal.render(),
    bulkRowActionsModal == null ? void 0 : bulkRowActionsModal.render(),
    copyAlertModal == null ? void 0 : copyAlertModal.render(),
    pasteAlertModal == null ? void 0 : pasteAlertModal.render(),
    deleteAlertModal == null ? void 0 : deleteAlertModal.render()
  ] });
};
export {
  TablePortal as default
};
